
export const csvValidator = (value) => {
    const regex = /^[=+\-@]/;
    return regex.test(value)
}